type HttpErrorDetailLike = {
    response?: { data?: { message?: unknown; errorId?: unknown } };
};

export type HttpErrorDetail = {
    message?: string;
    errorId?: string;
};

const nonEmptyString = (value: unknown): string | undefined =>
    typeof value === 'string' && value !== '' ? value : undefined;

const isObject = (value: unknown): value is object =>
    !!value && typeof value === 'object';

// Reads the API's { errorId, message } body from a rejected AxiosError.
export function httpErrorDetail(error: unknown): HttpErrorDetail {
    if (!isObject(error)) {
        return {};
    }

    const data = (error as HttpErrorDetailLike).response?.data;
    if (!isObject(data)) {
        return {};
    }

    return {
        message: nonEmptyString(data.message),
        errorId: nonEmptyString(data.errorId),
    };
}
